import React from 'react';
import PropTypes from 'prop-types';
import { Input, Icon } from 'semantic-ui-react';
import TableFileViewerWrapper from '../TableFileViewerWrapper';

const FileHandlerWrapper = ({
	api,
	files,
	name,
	handleFileChange,
	disabled,
	displayInput,
	errors,
	hideFile
}) => {
	function updateFiles(newFiles, isRemoval = false, indexToRemove = null) {
		if (newFiles) {
			// create deepcopy of each file, otherwise the 'deleted' property also changes in the original array
			const newFileArray = [...files.map(file => ({ ...file }))];

			//file removal
			if (isRemoval) {
				//logical removal if already saved
				if (newFileArray[indexToRemove].id) {
					newFileArray[indexToRemove].deleted = true;
				}
				//else actual removal
				else {
					newFileArray.splice(indexToRemove, 1);
				}
				//file addition
			} else {
				for (let i = 0; i < newFiles.length; i++) {
					const newFileName = newFiles[i].name
						.normalize('NFD')
						.replace(/[\u0300-\u036f]/g, '')
						.replace(/[^a-zA-Z0-9.()]/g, '_');
					const newFileData = {
						name: newFileName,
						format: newFiles[i].type
					}; //format used for type validation
					const reader = new FileReader();
					reader.onload = readerEvt => {
						newFileData.fileBase64 = window.btoa(readerEvt.target.result);
						newFileData.file = newFiles[i];
					};
					reader.readAsBinaryString(newFiles[i]);
					newFileArray.push(newFileData);
				}
			}
			handleFileChange(newFileArray);
		}
	}

	/**
	 * Get the file input area
	 * @returns {*}
	 */
	const getFileInput = () => (
		<>
			{!disabled && displayInput && (
				<div className="fileWrapperUploader">
					<label htmlFor={name}>
						<Icon link name="upload" size="large" />
					</label>
					<Input
						fluid
						id={name}
						name={name}
						type="file"
						multiple
						onChange={event => updateFiles(event.currentTarget.files)}
					/>
				</div>
			)}
		</>
	);

	return (
		<>
			{getFileInput()}
			{ files?.length > 0 &&
				<TableFileViewerWrapper
					api={api}
					name={name}
					value={files}
					valueLength={files?.length}
					onChangeValue={updateFiles}
					disabled={disabled}
					errors={errors}
					hideFile={hideFile}
				/>
			}
		</>
	);
};

FileHandlerWrapper.propTypes = {
	api: PropTypes.object.isRequired,
	files: PropTypes.array.isRequired,
	name: PropTypes.string.isRequired,
	handleFileChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	displayInput: PropTypes.bool,
	errors: PropTypes.object,
	hideFile: PropTypes.func
};

FileHandlerWrapper.defaultProps = {
	disabled: false,
	displayInput: true,
	errors: {},
	hideFile: () => false
};

export default FileHandlerWrapper;
